import { Component, OnDestroy, OnInit, signal } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { UserService } from '../../services/user.service';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { UpperCasePipe } from '@angular/common';
import { MessageComponent } from '../../modals/message/message.component';
import { Subscription } from 'rxjs';
import { ModalService } from '../../services/modal.service';
import { Utils } from '../../services/utils.service';

@Component({
  selector: 'app-register-feedback',
  imports: [TranslatePipe, UpperCasePipe],
  templateUrl: './register-feedback.component.html',
  styleUrls: ['./register-feedback.component.scss']
})
export class RegisterFeedbackComponent implements OnInit, OnDestroy {

  needsActivation = signal<boolean>(true);
  afterLogin = false;
  loaded = signal<boolean>(false);

  private routeSubscription?: Subscription;

  constructor(
    private router: Router,
    private spinner: NgxSpinnerService,
    private userService: UserService,
    private route: ActivatedRoute,
    private translate: TranslateService,
    private modalService: ModalService,
    private utils: Utils,
  ) {}

  ngOnInit(): void {
    this.routeSubscription = this.route.queryParams.subscribe(map => {
      if (map['afterLogin']) {
        this.afterLogin = true;
      }
    });
    this.spinner.show();
    this.userService.getUser().subscribe({
      next: user => {
        this.spinner.hide();
        this.needsActivation.set(!!(user?.emailActivationTermDate));
        this.loaded.set(true);
      },
      error: error => {
        this.spinner.hide();
        if (error.status === 401) {
          this.router.navigate(['/']);
        }
      }
    });
  }

  ngOnDestroy(): void {
    this.routeSubscription?.unsubscribe();
    this.routeSubscription = undefined;
  }

  associate() {
    this.router.navigate(['/products']);
  }

  resendActivationEmail() {
    this.spinner.show();
    this.userService.resendActivationEmail().subscribe({
      next: _ => {
        this.spinner.hide();
        const modal = this.modalService.show(MessageComponent);
        modal.componentInstance.message.set(this.translate.instant('mail_sent'));
      },
      error: error => {
        this.spinner.hide();
        this.utils.showMessage(error, this.translate.instant('network_request_error'));
      }
    });
  }
}
